import { createAction, props } from '@ngrx/store';

// Prettier 1.18.2 cannot parse `import type`, and the pre-commit hook runs it,
// so the types ride along on a plain import. TypeScript elides them.
import {
  QueueItem,
  UploadEntityType,
  UploadState,
} from 'capacitor-clogi-uploader';

export const uploadQueueSynced = createAction(
  '[Upload Queue] Synced',
  props<{ items: QueueItem[] }>()
);

export const uploadProgressed = createAction(
  '[Upload Queue] Progressed',
  props<{ id: string; bytesSent: number; bytesTotal: number }>()
);

export const uploadStateChanged = createAction(
  '[Upload Queue] State Changed',
  props<{
    id: string;
    entityId: string;
    entityType: UploadEntityType;
    state: UploadState;
    error?: string;
  }>()
);
